import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../app/api';

const initialState = {
    invoices: [],
    invoice: null,
    loading: false,
    error: null,
};

export const addInvoice = createAsyncThunk(
    'invoice/addInvoice',
    async ({
        date, number, type_of_payment, type_of_document, bank_account, total, productTables, company_id, client_id, vat, total_with_vat, reference_invoice_number
    }, { rejectWithValue }) => {
        try {
            const response = await api.post('/invoice/addInvoice', {
                date, number, type_of_payment, type_of_document, bank_account, total, productTables, company_id, client_id, vat, total_with_vat, reference_invoice_number
             });
            return response.data;
        } catch (error) {
            // Extract error message from response if available
            const errorMessage = error.response?.data?.message || error.message || 'Грешка при създаване на фактура';
            console.error('addInvoice error:', error.response?.data || error);
            return rejectWithValue(errorMessage);
        }
    }   
);

export const cancelInvoice = createAsyncThunk(
    'invoice/cancelInvoice',
    async ({id, type_of_document}, { rejectWithValue }) => {
        try {
            console.log('cancelInvoice thunk called with:', { id, type_of_document });
            const response = await api.post(`/invoice/cancelInvoice/${id}`, { type_of_document });
            console.log('cancelInvoice API response:', response.data);
            return response.data;
        } catch (error) {
            console.error('cancelInvoice thunk error:', error);
            return rejectWithValue(error.message || 'An error occurred');
        }
    }
);

export const generateNextInvoiceNumber = createAsyncThunk(
    'invoice/generateNextInvoiceNumber',
    async (dispatch, { rejectWithValue }) => {
        try {
            const response = await api.post('/invoice/generateNextInvoiceNumber', {
                company_id: dispatch.company_id
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }
);

export const getCompanyInvoices = createAsyncThunk(
    'invoice/getCompanyInvoices',
    async (dispatch, { rejectWithValue }) => {
        try {
            const response = await api.post('/invoice/getCompanyInvoices', {
                company_id: dispatch.company_id 
            });
            return response.data;   
        } catch (error) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }   
);

export const deleteIncome = createAsyncThunk(
    'invoice/deleteIncome',
    async ({id, type}, { rejectWithValue }) => {
        try {
            const response = await api.post(`/invoice/deleteIncome/${id}`, { type });
            return response.data;             
        } catch (error) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }
);

export const getInvoice = createAsyncThunk(
    'invoice/getInvoice',
    async (id, { rejectWithValue }) => {
        try {
            const invoiceId = typeof id === 'object' ? id.id : id;
            const response = await api.post(`/invoice/getInvoice/${invoiceId}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }
);

export const editInvoice = createAsyncThunk(
    'invoice/editInvoice',
    async ({
        id, date, type_of_payment, bank_account, total, productTables, company_id, client_id, vat, total_with_vat
    }, { rejectWithValue }) => {
        try {
            const response = await api.post(`/invoice/editInvoice/${id}`, {
                date, type_of_payment, bank_account, total, productTables, company_id, client_id, vat, total_with_vat
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }
);

export const generateInvoice = createAsyncThunk(
    'invoice/generateInvoice',
    async ({ id },{ rejectWithValue }) => {
        try {
            const response = await api.post('/invoice/generateInvoice', {
                id
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message || 'An error occurred');   
        }   
    }
);


const clientsSlice = createSlice({
    name: 'invoices',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(addInvoice.pending, (state) => {
                state.loading = true;
            })
            .addCase(addInvoice.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(addInvoice.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(generateNextInvoiceNumber.pending, (state) => {
                state.loading = true;
            })
            .addCase(generateNextInvoiceNumber.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(generateNextInvoiceNumber.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getCompanyInvoices.pending, (state) => {
                state.loading = true;
            })
            .addCase(getCompanyInvoices.fulfilled, (state, action) => {
                state.loading = false;
                state.invoices = action.payload.invoices;
            })
            .addCase(getCompanyInvoices.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deleteIncome.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteIncome.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(deleteIncome.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getInvoice.pending, (state) => {
                state.loading = true;
            })
            .addCase(getInvoice.fulfilled, (state, action) => {
                state.loading = false;
                state.invoice = action.payload;
            })
            .addCase(getInvoice.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(editInvoice.pending, (state) => {
                state.loading = true;
            })
            .addCase(editInvoice.fulfilled, (state, action) => {
                state.loading = false;
                if (state.invoice && state.invoice.id === action.meta.arg.id) {
                    state.invoice = {
                        ...state.invoice,
                        ...action.meta.arg
                    };
                }
                if (state.invoices) {
                    state.invoices = state.invoices.map(inv => 
                        inv.id === action.meta.arg.id 
                            ? { ...inv, ...action.meta.arg }
                            : inv
                    );
                }
            })
            .addCase(editInvoice.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(cancelInvoice.pending, (state) => {
                console.log('cancelInvoice pending');
                state.loading = true;
                state.error = null;
            })
            .addCase(cancelInvoice.fulfilled, (state, action) => {
                console.log('cancelInvoice fulfilled with action:', action);
                state.loading = false;
                state.error = null;
                if (state.invoices) {
                    console.log('Updating invoices in state, looking for ID:', action.meta.arg.id);
                    state.invoices = state.invoices.map(inv => {
                        if (inv.id === action.meta.arg.id) {
                            console.log('Found invoice to update:', inv);
                            return { ...inv, type_of_document: 'cancelled' };
                        }
                        return inv;
                    });
                }
                if (state.invoice && state.invoice.id === action.meta.arg.id) {
                    console.log('Updating single invoice in state');
                    state.invoice = { ...state.invoice, type_of_document: 'cancelled' };
                }
            })
            .addCase(cancelInvoice.rejected, (state, action) => {
                console.log('cancelInvoice rejected with action:', action);
                state.loading = false;
                state.error = action.payload;
            })
    }
});

export default clientsSlice.reducer;